module.exports = __webpack_public_path__ + "static/media/airtime_data.dd3443ee.svg";